function validate_length_min_4(input) {
  return input.length < 4
}

export default validate_length_min_4
